.prompt {
    font-size: 32px;
    font-weight: 500;
    font-family: 'Doyle';
    line-height: 1.5;
    color: var(--grey-dk);
}
